import type { Messages } from '../catalogue.en'

/**
 * Laboratory recognition of a file: the Files row's words for where it stands,
 * the replacement question, the progress and page-choice stops, cancellation
 * and why a recognition stopped.
 */
export const laboratoryRecognition: Partial<Messages> = {
  'lab.recognition.notLaboratoryFile': 'Этот файл не отнесён к результатам лабораторных анализов.',
  'lab.recognition.batchRecognize': 'Распознать выбранные файлы ({count})',
  'lab.recognition.workspaceTitle': 'Распознавание результатов анализов',
  'lab.recognition.backToFiles': 'К файлам с анализами',
  'lab.recognition.batchSummary': 'Файлов: {files} · Страниц: {pages} · Выбрано: {selected}',
  'lab.recognition.batchFiles': 'Файлы в распознавании',
  'lab.recognition.recognizeBatch': 'Распознать выбранные страницы',
  'lab.recognition.pagesPanel': 'Страницы документов',
  'lab.recognition.showPages': 'Показать панель',
  'lab.recognition.hidePages': 'Свернуть панель',
  'lab.recognition.showPage': 'Показать страницу {number} файла {name}',
  'lab.recognition.includePage': 'Распознать страницу {number}',
  'lab.recognition.rowRecognize': 'Распознать',
  'lab.recognition.notStarted': 'Распознавание ещё не запущено.',
  'lab.recognition.rowRecognizeNamed': 'Распознать результаты анализов в файле {name}',
  'lab.recognition.rowReading': 'Чтение страниц…',
  'lab.recognition.rowReadingNamed': 'Чтение страниц файла {name}',
  'lab.recognition.rowChoosePages': 'Выбрать страницы',
  'lab.recognition.rowChoosePagesNamed': 'Выбрать страницы файла {name} для распознавания',
  'lab.recognition.rowRecognizing': 'Распознавание: {done} из {total}',
  'lab.recognition.rowRecognizingNamed': 'Распознавание файла {name}: готово страниц {done} из {total}',
  'lab.recognition.rowReview': 'Проверить черновик',
  'lab.recognition.rowReviewNamed': 'Проверить результаты, распознанные в файле {name}',
  'lab.recognition.rowFailed': 'Распознавание остановлено',
  'lab.recognition.rowFailedNamed': 'Распознавание файла {name} остановлено: открыть',
  'lab.recognition.rowConfirmed': 'Подтверждено {date}',
  'lab.recognition.rowConfirmedNamed': 'Открыть отчёт из файла {name}, подтверждённый {date}',
  'lab.recognition.rowAgain': 'Распознать заново',
  'lab.recognition.rowAgainNamed': 'Распознать файл {name} заново',
  'lab.recognition.starting': 'Запуск распознавания…',
  'lab.recognition.gone': 'Этого распознавания больше нет. Возможно, его отменили в другом месте.',
  'lab.recognition.loadFailed':
    'Не удалось прочитать распознавание. Вернитесь к списку файлов и откройте его снова.',
  'lab.recognition.replaceTitle': 'Распознать документ заново?',
  'lab.recognition.replaceDetail':
    'Когда новое распознавание будет подтверждено, результаты, распознанные из этого документа, будут удалены из карты. Результатов: {count}, отчёт от {date}.',
  'lab.recognition.replaceKept':
    'До этого они остаются в карте, а отмена нового распознавания их не затронет. Документ будет распознан с нуля.',
  'lab.recognition.replaceKeep': 'Оставить текущие результаты',
  'lab.recognition.analysingDetail':
    'Читаем страницы и ищем те, на которых есть результаты анализов. Затем вы выберете страницы для распознавания.',
  'lab.recognition.recognizingDetail': 'Распознаём выбранные страницы.',
  'lab.recognition.progress': 'Распознано страниц: {done} из {total}',
  'lab.recognition.keepsWorking':
    'Можно уйти с этой страницы. Распознавание продолжится, а статус в строке файла подскажет, когда понадобится ваше участие.',
  'lab.recognition.pagesTitle': 'Выберите страницы для распознавания',
  'lab.recognition.pagesDetail':
    'Отмечены страницы, похожие на результаты анализов. Распознаются только отмеченные: снимите отметку с лишней страницы или отметьте пропущенную.',
  'lab.recognition.page': 'Страница {number}',
  'lab.recognition.enlargePage': 'Увеличить страницу {number}',
  'lab.recognition.pageImage': 'Страница документа {number}',
  'lab.recognition.pageImageUnavailable': 'Изображение недоступно',
  'lab.recognition.markLaboratory': 'Результаты анализов',
  'lab.recognition.markOther': 'Другое содержимое',
  'lab.recognition.markNoText': 'Текст не найден',
  'lab.recognition.chosenCount': 'Выбрано страниц: {count}',
  'lab.recognition.recognizeChosen': 'Распознать выбранное',
  'lab.recognition.addPages': 'Добавить страницы',
  'lab.recognition.addPagesTitle': 'Добавить страницы в черновик',
  'lab.recognition.addPagesDetail':
    'Уже распознанные страницы остаются в черновике, сохранённые правки тоже. Выберите, какие страницы распознать дополнительно.',
  'lab.recognition.recognizeAdded': 'Распознать добавленные',
  'lab.recognition.backToDraft': 'Вернуться к черновику',
  'lab.recognition.sending': 'Отправка…',
  'lab.recognition.cannotRun': 'Для распознавания страниц нужно право запускать функции ИИ.',
  'lab.recognition.pagesFailed': 'Не удалось отправить выбор страниц. Попробуйте ещё раз.',
  'lab.recognition.failedTitle': 'Распознавание остановлено.',
  'lab.recognition.retry': 'Повторить',
  'lab.recognition.retrying': 'Перезапуск…',
  'lab.recognition.retryFailed': 'Не удалось перезапустить распознавание. Попробуйте ещё раз.',
  'lab.recognition.cancel': 'Отменить распознавание',
  'lab.recognition.cancelQuestion':
    'Отменить это распознавание? Всё, что оно успело прочитать, будет удалено. Подтверждённые результаты останутся без изменений.',
  'lab.recognition.cancelKeep': 'Продолжить распознавание',
  'lab.recognition.cancelConfirm': 'Отменить распознавание',
  'lab.recognition.cancelling': 'Отмена…',
  'lab.recognition.cancelFailed': 'Не удалось отменить распознавание. Попробуйте ещё раз.',
  'lab.recognition.cancelChanged': 'Состояние распознавания изменилось. Перезагрузите его перед отменой.',
  'lab.recognition.cancelReload': 'Перезагрузить состояние распознавания',
  'lab.recognition.cancelReloadFailed': 'Не удалось загрузить состояние распознавания. Попробуйте перезагрузить его ещё раз.',
  'lab.recognition.cancelReloaded': 'Показано текущее состояние распознавания. Подтвердите отмену ещё раз, если хотите его удалить.',
  'lab.recognition.stageConflict':
    'Распознавание уже изменилось в другом месте. Вернитесь к списку файлов и откройте его снова.',
  'lab.recognition.failureDisabled':
    'Распознавание анализов выключено в этой клинике. Администратор может включить его в настройках ИИ.',
  'lab.recognition.failureGoogle':
    'Google Document AI не настроен для этой клиники. Администратор может добавить его в настройках ИИ.',
  'lab.recognition.failureTooLarge': 'Документ слишком большой или в нём слишком много страниц для распознавания.',
  'lab.recognition.failureUnreadable': 'Не удалось прочитать страницы документа. Проверьте, что файл открывается.',
  'lab.recognition.failureUnavailable': 'Исходный файл больше недоступен.',
  'lab.recognition.failureQuota': 'Хранилище клиники заполнено, поэтому страницы не удалось сохранить.',
  'lab.recognition.failureService': 'Сервис распознавания не ответил. Попробуйте позже.',
  'lab.recognition.failureAnswer': 'Ответ распознавания не удалось использовать. Попробуйте ещё раз.',
  'lab.recognition.failureUnknown':
    'Распознавание столкнулось с непредвиденной ошибкой. Попробуйте ещё раз и сообщите администратору, если ошибка повторится.',
}
